/**
 * Available Pos Product Search
 */
export enum PosProductSearchNameValueEnum {
  POS_PRODUCT_SEARCH = 'POS Product Search',
  POS_MENU = 'POS Menu'
}

export enum PosProductSearchEnum {
  POS_PRODUCT_SEARCH = 1,
  POS_MENU = 2
}